import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import "../../styles/MyProfile.css";

const EducationProfile = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData] = useFetch();
  const userId = authState.user._id;

  const [profileData, setProfileData] = useState({
    userId: userId,
    think5whysCode: authState.user.think5whyscode,
    name: authState.user.name,
    gender: 0,  
    dob: null, 
    email: authState.user.email,
    mobile: '',
    referredBy: '',
    outlookDetails: '',  
    healthDetails: '',   
    bloodGroup: '',      
    address: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    
    emergencyContactName: '',      
    emergencyContactRelation: '',  
    emergencyContactEmail: '',     
    emergencyContactMobile: '',    

    jobTitle: '',        
    department: '',      
    currentCompany: '',  
    doJoining: null,       

    kycVerified: false,  
    kycVerifiedBy: null, 
    kycVerifiedDate: null, 
    poaDocType: '',        
    poaDocDetails: '',     
    poiDocType: '',        
    poiDocDetails: '',     
    insuranceDetails: '',  

    isSignature: false,      
    isBiometric: false,      
    biometricType: '',       

    cardIssuedBy: "Think5Whys Global DeepTech Solutions", 
    issueDate: null,     
    expiryDate: null,    
    specialRemarks: '', 

    isAvailable: true, 
    availableForWork: '',
    availabilityRemarks: '', 
    socialLinks: '',
    personalPageLink: '',
    bio: '',

    feedback: [], 

    isActive: true,    
    isDeleted: false,  
    createdBy: userId, 
    dateCreated: new Date(),  
    dateUpdated: new Date(),  
  });


  const [originalProfileData, setOriginalProfileData] = useState({});
  const [profileExists, setProfileExists] = useState(false);
  const [profileId, setProfileId] = useState('');
  const [loading, setLoading] = useState(true);
  const [createSuccess, setCreateSuccess] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [createSuccessMsg, setCreateSuccessMsg] = useState('');
  const [updateSuccessMsg, setUpdateSuccessMsg] = useState('');
  const [creatingProfile, setCreatingProfile] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchUserProfile(userId);
  }, [userId]);

  const fetchUserProfile = useCallback(() => {
    try {
      const config = {
        url: "/educationprofile/byid",
        method: 'post',
        data: { userId: userId },
        headers: { Authorization: authState.token },
      };
      fetchData(config)
        .then(response => {
          if (response && response.status) {
            // console.log("profile exists ",response);
            setProfileExists(true);
            const { educationProfile } = response;
            setProfileId(educationProfile._id);
            setProfileData(educationProfile);
          } else {
            setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
          }
        })
        .catch(() => {
          setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
        });
    } catch {
      setCreateSuccessMsg("Sorry! Profile not found. Please retry.");
    }
  }, [userId, fetchData, setProfileExists]);

  const handleProfileUpdate = useCallback(() => {
    validateInputs();
    const config = {
      url: `/educationprofile/updateprofile`,
      method: 'post',
      data: { profileData: profileData, userId: userId},
      headers: { Authorization: authState.token },
    };
    fetchData(config)
      .then(response => {
        if (response && response.status) {
          setOriginalProfileData(profileData);
          setUpdateSuccess(true);
          setUpdateSuccessMsg("Profile updated successfully!");
        } else {
          setUpdateSuccessMsg("Error updating profile! Please retry.");
        }
      })
      .catch(() => {
        setUpdateSuccessMsg("Error updating profile! Please retry.");
      });
  }, [profileData, profileId, fetchData]);

  const handleCancel = () => {
    setProfileData(originalProfileData);
  };

  const handleCreateProfile = () => {
    setCreatingProfile(true);
    fetchProfileCreate();
  };

  const fetchProfileCreate = useCallback(() => {
    const config = {
      url: "/educationprofile",
      method: 'post',
      data: profileData,
      headers: { Authorization: authState.token },
    };
    fetchData(config)
      .then(response => {
        if (response && response.status) {
          setCreateSuccess(true);
          setCreateSuccessMsg("Profile Created Successfully");
        } else {
          setCreateSuccessMsg("Sorry! Profile Not Created. Please retry.");
        }
      })
      .catch(() => {
        setCreateSuccessMsg("Sorry! Profile Not Created. Please retry.");
      });
  }, [profileData, fetchData]);

  const validateInputs = () => {
    let isValid = true;
    const errors = {};
    const mobileRegex = /^\d{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (profileData.gender === undefined || profileData.gender === null) {
      errors.gender = 'Gender is required.';
      isValid = false;
    }

    if (!profileData.dob) {
      errors.dob = 'Date of Birth is required.';
      isValid = false;
    }

    if (!emailRegex.test(profileData.email)) {
      setMessage("Please enter a valid email address.");
      isValid = false;
    }

    // if (!profileData.mobile) {
    //   errors.mobile = 'Mobile Number is required.';
    //   isValid = false;
    // } else if (!mobileRegex.test(profileData.mobile)) {
    //   errors.mobile = 'Mobile Number must be exactly 10 digits.';
    //   isValid = false;
    // }

    if (profileData.mobile && profileData.mobile.trim() !== '') {
      if (!mobileRegex.test(profileData.mobile)) {
        errors.mobile = 'Mobile Number must be exactly 10 digits and start with a digit other than 0.';
        isValid = false;
      }
    }

    if (!profileData.state) {
      errors.state = 'State is required.';
      isValid = false;
    }
    if (!profileData.city) {
      errors.city = 'City is required.';
      isValid = false;
    }
    if (!profileData.country) {
      errors.country = 'Country is required.';
      isValid = false;
    }
    if (!profileData.address) {
      errors.address = 'Address is required.';
      isValid = false;
    }
    if (!profileData.pincode) {
      errors.pincode = 'Pincode is required.';
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  return (
    <MainLayout>
      <div className='text-lg mt-12 mb-4 mx-8'>
        <h2 className='text-2xl font-bold text-white text-center mb-6'>My Education Job Profile</h2>
      </div>
      <div className='min-h-[50vh] mt-4 border border-b-gray-300 p-6 rounded-lg bg-gray-800 text-white'>
        {!profileExists && (
          <div className='flex justify-center items-center mt-4'>
            <button
              className='create-profile-button px-4 py-2 bg-blue-600 rounded-full text-white hover:bg-blue-700'
              onClick={handleCreateProfile}
              disabled={creatingProfile}
            >
              Initiate Your Education Job Profile Creation
            </button>
          </div>
        )}
        
        {profileExists && (
          <>
            <div className='flex flex-col gap-4'>
              <div className='flex flex-col'>
                <label className='text-yellow-200'>Name:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.name}
                  disabled
                />
              </div>

              <div className='flex flex-col'>
                <label className='text-yellow-200'>User Code:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  style={{width: "250px"}}
                  value={profileData.think5whysCode}
                  disabled
                />
              </div>

              <div className='flex flex-col'>
                <label className='text-yellow-200'>Reference Code:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  style={{width: "250px"}}
                  value={profileData.referredBy}
                  onChange={(e) => setProfileData({ ...profileData, referredBy: e.target.value })}
                />
              </div>

              <div className='flex flex-col'>
                <label>Gender:</label>
                <select
                  className="profile-select bg-gray-600 rounded-md px-2 py-1"
                  value={profileData.gender}
                  onChange={(e) => setProfileData({ ...profileData, gender: e.target.value })}
                >
                  <option value={0}>Male</option>
                  <option value={1}>Female</option>
                  <option value={2}>Other</option>
                </select>
                {errors.gender && <span className="text-red-500 text-xs">{errors.gender}</span>}
              </div>

              {/* Date of Birth */}
              <div className='flex flex-col'>
                <label>Date of Birth:</label>
                <input
                  className="profile-date bg-gray-600 rounded-md px-2 py-1"
                  type="date"
                  value={profileData.dob ? profileData.dob.substring(0, 10) : ''}
                  onChange={(e) => setProfileData({ ...profileData, dob: e.target.value })}
                />
              </div>

              {/* Email */}
              <div className='flex flex-col'>
                <label className='text-yellow-200'>Email:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="email"
                  value={profileData.email}
                  disabled
                />
              </div>

              {/* Mobile Number */}
              <div className='flex flex-col'>
                <label className='text-yellow-200'>Mobile Number:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="tel"
                  value={profileData.mobile}
                  onChange={(e) => setProfileData({ ...profileData, mobile: e.target.value })}
                />
                {errors.mobile && <span className="text-red-500 text-xs">{errors.mobile}</span>}
              </div>

              {/* City */}
              <div className='flex flex-col'>
                <label className='text-yellow-200'>City:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.city}
                  style={{width:'250px'}}
                  onChange={(e) => setProfileData({ ...profileData, city: e.target.value })}
                />
              </div>

              {/* State */}
              <div className='flex flex-col'>
                <label>State:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.state}
                  style={{width:'250px'}}
                  onChange={(e) => setProfileData({ ...profileData, state: e.target.value })}
                />
              </div>

              {/* Country */}
              <div className='flex flex-col'>
                <label>Country:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.country}
                  style={{width:'250px'}}
                  onChange={(e) => setProfileData({ ...profileData, country: e.target.value })}
                />
              </div>

              {/* Postal Code */}
              <div className='flex flex-col'>
                <label>Postal Code:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.pincode}
                  style={{width:'200px'}}
                  onChange={(e) => setProfileData({ ...profileData, pincode: e.target.value })}
                />
              </div>

              {/* Address */}
              <div className='flex flex-col'>
                <label>Address:</label>
                <textarea
                  className="bg-gray-600 rounded-md px-2 py-1"
                  style={{width:'100%', height: '150px'}}
                  value={profileData.address}
                  onChange={(e) => setProfileData({ ...profileData, address: e.target.value })}
                />
              </div>

              {/* Emergency Contact Name */}
              <div className='flex flex-col'>
                <label className='text-yellow-200'>Emergency Contact Name:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.emergencyContactName}
                  onChange={(e) => setProfileData({ ...profileData, emergencyContactName: e.target.value })}
                />
              </div>

              {/* Emergency Contact Relation */}
              <div className='flex flex-col'>
                <label>Emergency Contact Relation:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.emergencyContactRelation}
                  style={{ width: '250px' }}
                  onChange={(e) => setProfileData({ ...profileData, emergencyContactRelation: e.target.value })}
                />
              </div>

              {/* Emergency Contact Email */}
              <div className='flex flex-col'>
                <label>Emergency Contact Email:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="email"
                  value={profileData.emergencyContactEmail}
                  onChange={(e) => setProfileData({ ...profileData, emergencyContactEmail: e.target.value })}
                />
              </div>

              {/* Emergency Contact Mobile */}
              <div className='flex flex-col'>
                <label>Emergency Contact Mobile:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="tel"
                  value={profileData.emergencyContactMobile}
                  onChange={(e) => setProfileData({ ...profileData, emergencyContactMobile: e.target.value })}
                />
              </div>

              {/* Job Title */}
              <div className='flex flex-col'>
                <label>Job Title:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.jobTitle}
                  onChange={(e) => setProfileData({ ...profileData, jobTitle: e.target.value })}
                />
              </div>

              {/* Department */}
              <div className='flex flex-col'>
                <label>Department:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.department}
                  onChange={(e) => setProfileData({ ...profileData, department: e.target.value })}
                />
              </div>

              {/* Current Company */}
              <div className='flex flex-col'>
                <label>Current Company:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.currentCompany}
                  onChange={(e) => setProfileData({ ...profileData, currentCompany: e.target.value })}
                />
              </div>

              {/* Date of Joining */}
              <div className='flex flex-col'>
                <label>Date of Joining:</label>
                <input
                  className="profile-date bg-gray-600 rounded-md px-2 py-1"
                  type="date"
                  value={profileData.doJoining ? profileData.doJoining.substring(0, 10) : ''}
                  onChange={(e) => setProfileData({ ...profileData, doJoining: e.target.value })}
                />
              </div>

              <div className='flex flex-col'>
                <label>Social / Personal Page Link:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.personalPageLink}
                  onChange={(e) => setProfileData({ ...profileData, personalPageLink: e.target.value })}
                />
              </div>
            </div>

            {/* Outlook Details */}
            <div className='flex flex-col'>
              <label>Outlook Details:</label>
              <textarea
                className="bg-gray-600 rounded-md px-2 py-1"
                style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '150px' }}
                value={profileData.outlookDetails}
                onChange={(e) => setProfileData({ ...profileData, outlookDetails: e.target.value })}
              />
            </div>

            {/* Health Details */}
            <div className='flex flex-col'>
              <label>Health Details:</label>
              <textarea
                className="bg-gray-600 rounded-md px-2 py-1"
                style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '150px' }}
                value={profileData.healthDetails}
                onChange={(e) => setProfileData({ ...profileData, healthDetails: e.target.value })}
              />
            </div>

            {/* Blood Group */}
            <div className='flex flex-col'>
              <label>Blood Group:</label>
              <input
                className="profile-input bg-gray-600 rounded-md px-2 py-1"
                type="text"
                value={profileData.bloodGroup}
                style={{ width: '100px' }}
                onChange={(e) => setProfileData({ ...profileData, bloodGroup: e.target.value })}
              />
            </div>

            {/* POA Document Type */}
            <div className='flex flex-col'>
              <label>Proof of Address Document Type:</label>
              <input
                className="profile-input bg-gray-600 rounded-md px-2 py-1"
                type="text"
                value={profileData.poaDocType}
                style={{ width: '300px' }}
                onChange={(e) => setProfileData({ ...profileData, poaDocType: e.target.value })}
              />
            </div>

            {/* POA Document Details */}
            <div className='flex flex-col'>
              <label>Proof of Address Document Details:</label>
              <textarea
                className="bg-gray-600 rounded-md px-2 py-1"
                style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '150px' }}
                value={profileData.poaDocDetails}
                onChange={(e) => setProfileData({ ...profileData, poaDocDetails: e.target.value })}
              />
            </div>

            {/* POI Document Type */}
            <div className='flex flex-col'>
              <label>Proof of Identity Document Type:</label>
              <input
                className="profile-input bg-gray-600 rounded-md px-2 py-1"
                type="text"
                value={profileData.poiDocType}
                style={{ width: '300px' }}
                onChange={(e) => setProfileData({ ...profileData, poiDocType: e.target.value })}
              />
            </div>

            {/* POI Document Details */}
            <div className='flex flex-col'>
              <label>Proof of Identity Document Details:</label>
              <textarea
                className="bg-gray-600 rounded-md px-2 py-1"
                style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '150px' }}
                value={profileData.poiDocDetails}
                onChange={(e) => setProfileData({ ...profileData, poiDocDetails: e.target.value })}
              />
            </div>

            {/* Bio */}
            <div className='flex flex-col'>
              <label>About / Brief Bio:</label>
              <textarea
                className="bg-gray-600 rounded-md px-2 py-1"
                style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '250px' }}
                value={profileData.bio}
                onChange={(e) => setProfileData({ ...profileData, bio: e.target.value })}
              />
            </div>

            {/* Special Remarks */}
            <div className='flex flex-col'>
              <label>Special Remarks:</label>
              <textarea
                className="bg-gray-600 rounded-md px-2 py-1"
                style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '150px' }}
                value={profileData.specialRemarks}
                onChange={(e) => setProfileData({ ...profileData, specialRemarks: e.target.value })}
              />
            </div>

            {/* Availability Remarks */}
            <div className='flex flex-col'>
              <label>Availability Remarks:</label>
              <textarea
                className="bg-gray-600 rounded-md px-2 py-1"
                style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '150px' }}
                value={profileData.availabilityRemarks}
                onChange={(e) => setProfileData({ ...profileData, availabilityRemarks: e.target.value })}
              />
            </div>

            {updateSuccess && (
              <div className="success-message text-green-500 text-lg mt-4">
                {updateSuccessMsg}
              </div>
            )}
            <div className='flex mt-6'>
              <button
                className='update-profile-button px-4 py-2 bg-green-600 rounded-full text-white hover:bg-green-700 w-40'
                onClick={handleProfileUpdate}
              >
                Update
              </button>
              <button
                className='update-profile-button px-4 py-2 bg-red-600 rounded-full text-white hover:bg-red-700 w-40'
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </>
        )}

        {!profileExists && createSuccess && (
          <div className="flex flex-col justify-center success-message text-green-500 text-xl mt-4">
            {createSuccessMsg}
            <button
                className='update-profile-button px-4 py-2 bg-red-600 rounded-full text-white hover:bg-red-700 w-40'
                onClick={() => navigate("/my-profile-home")}
              >
                OK
            </button>
          </div>
        )}
     </div>
    </MainLayout>
  );
};

export default EducationProfile;



